var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("改标录入记录列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          attrs: { gutter: 20, type: "flex", align: "middle", justify: "start" }
        },
        _vm._l(_vm.storehouseIds, function(item) {
          return _c(
            "div",
            {
              key: item.key,
              staticClass: "status",
              class: { active: _vm.form.origin === item.key },
              on: {
                click: function($event) {
                  return _vm.selectOrigin(item.key)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "改标人" },
                                  model: {
                                    value: _vm.form.gb_user_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "gb_user_name", $$v)
                                    },
                                    expression: "form.gb_user_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "sku编码" },
                                  model: {
                                    value: _vm.form.sku,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sku", $$v)
                                    },
                                    expression: "form.sku"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "打标id" },
                                  model: {
                                    value: _vm.form.dbid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "dbid", $$v)
                                    },
                                    expression: "form.dbid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "货号" },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "波次单号" },
                                  model: {
                                    value: _vm.form.wave_picking_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wave_picking_no", $$v)
                                    },
                                    expression: "form.wave_picking_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "用户ID" },
                                  model: {
                                    value: _vm.form.user_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "user_id", $$v)
                                    },
                                    expression: "form.user_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-cascader", {
                                  attrs: {
                                    placeholder: "请选择商品分类",
                                    props: _vm.goodsCatProps
                                  },
                                  model: {
                                    value: _vm.form.cat_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cat_id", $$v)
                                    },
                                    expression: "form.cat_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择改标类型" },
                                    model: {
                                      value: _vm.form.gb_type_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "gb_type_id", $$v)
                                      },
                                      expression: "form.gb_type_id"
                                    }
                                  },
                                  [
                                    _c("el-option", { attrs: { value: "" } }, [
                                      _vm._v("全部")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.gbTypeList, function(item) {
                                      return _c(
                                        "el-option",
                                        {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id
                                          }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "是否出库" },
                                    model: {
                                      value: _vm.form.is_stock_out,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_stock_out", $$v)
                                      },
                                      expression: "form.is_stock_out"
                                    }
                                  },
                                  _vm._l(_vm.stockOutOption, function(item) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "是否高级质检" },
                                    model: {
                                      value: _vm.form.high_quality,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "high_quality", $$v)
                                      },
                                      expression: "form.high_quality"
                                    }
                                  },
                                  _vm._l(_vm.generalOption, function(item) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "商品类型" },
                                    model: {
                                      value: _vm.form.goods_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "goods_type", $$v)
                                      },
                                      expression: "form.goods_type"
                                    }
                                  },
                                  _vm._l(_vm.goodsTypeMenuSelected, function(
                                    item
                                  ) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "入库时间：" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "370px" },
                                  attrs: {
                                    type: "datetimerange",
                                    "default-time": ["06:00:00", "06:00:00"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.stock_in_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "stock_in_time", $$v)
                                    },
                                    expression: "form.stock_in_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "改标时间：" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "370px" },
                                  attrs: {
                                    type: "datetimerange",
                                    "default-time": ["06:00:00", "06:00:00"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.gb_input_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "gb_input_time", $$v)
                                    },
                                    expression: "form.gb_input_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.reset }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.list
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.list,
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "dbid",
                            label: "打标id",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sku",
                            label: "sku编码",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "first_cat",
                            label: "一级分类",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "second_cat",
                            label: "二级分类",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "third_cat",
                            label: "三级分类",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "market_name",
                            label: "市场",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brand_name",
                            label: "品牌",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_in_time",
                            label: "入库时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "gb_input_time",
                            label: "改标时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "gb_user_name",
                            label: "改标人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "gb_type_name",
                            label: "改标类型",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_type_str",
                            label: "商品类型",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "user_id",
                            label: "用户id",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wave_picking_no",
                            label: "波次单",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "high_quality_text",
                            label: "是否高级质检",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "is_stock_out",
                            label: "是否出库",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "120",
                            align: "center",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleUpdateType(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                修改\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          "margin-top": "10px",
                                          "margin-left": "0"
                                        },
                                        attrs: {
                                          type: "warning",
                                          size: "mini"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDelete(
                                              scope.row.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                删除\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          "margin-top": "10px",
                                          "margin-left": "0"
                                        },
                                        attrs: { type: "info", size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleViewLog(
                                              scope.row.dbid
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                操作日志\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            755171859
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.list
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.form.page,
                        "page-sizes": [50, 100],
                        background: "",
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.count,
                        "page-size": _vm.form.psize
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "改标类型修改",
            visible: _vm.dialogChangeTypeVisible,
            width: "600px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogChangeTypeVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "updateTypeForm",
              staticClass: "radio-group-wrap",
              attrs: { model: _vm.updateTypeForm }
            },
            [
              _c(
                "div",
                { staticClass: "radio-group" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("商品类型")]),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.updateTypeForm.goods_type,
                        callback: function($$v) {
                          _vm.$set(_vm.updateTypeForm, "goods_type", $$v)
                        },
                        expression: "updateTypeForm.goods_type"
                      }
                    },
                    _vm._l(_vm.goodsTypeMenu, function(item, key) {
                      return _c(
                        "div",
                        { key: key, staticStyle: { "margin-bottom": "10px" } },
                        [
                          _c("el-radio", { attrs: { label: item.value } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.label) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "radio-group type" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("改标类型")]),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.updateTypeForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.updateTypeForm, "type", $$v)
                        },
                        expression: "updateTypeForm.type"
                      }
                    },
                    _vm._l(_vm.gbTypeList, function(item, key) {
                      return _c(
                        "div",
                        { key: key, staticStyle: { "margin-bottom": "10px" } },
                        [
                          _c("el-radio", { attrs: { label: item.id } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: { click: _vm.handleChangeTypeCancel }
                },
                [_vm._v("\n        取 消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.handleChangeTypeConfirm }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showDialogLog, title: "操作日志" },
          on: {
            "update:visible": function($event) {
              _vm.showDialogLog = $event
            }
          }
        },
        [
          _c("YsDataTable", {
            attrs: {
              "init-params": _vm.initParamsLog,
              "fetch-method": _vm.fetchMethodLog,
              columns: _vm.columnsLog,
              "use-pagination": false,
              "use-data-field": ""
            },
            model: {
              value: _vm.refreshLog,
              callback: function($$v) {
                _vm.refreshLog = $$v
              },
              expression: "refreshLog"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03ff7da1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ff7da1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GaiBiao/GbInputRecord.vue
// module id = null
// module chunks = 